// Sensor data for the map
export const sensorData = [
  {
    id: 1,
    name: "Soil Moisture Sensor 1",
    type: "moisture",
    location: [12.505, 41.895],
    value: 78,
    unit: "%",
    lastUpdated: "2023-11-01T10:30:00Z",
    battery: 92
  },
  {
    id: 2,
    name: "Temperature Sensor 1",
    type: "temperature",
    location: [12.515, 41.885],
    value: 24.3,
    unit: "°C",
    lastUpdated: "2023-11-01T10:35:00Z",
    battery: 87
  },
  {
    id: 3,
    name: "Soil Moisture Sensor 2",
    type: "moisture",
    location: [12.525, 41.865],
    value: 42,
    unit: "%",
    lastUpdated: "2023-11-01T10:32:00Z",
    battery: 65,
    alert: true,
    alertMessage: "Low moisture level"
  },
  {
    id: 4,
    name: "Weather Station 1",
    type: "weather",
    location: [12.51, 41.905],
    temperature: 22.7,
    humidity: 68,
    windSpeed: 12,
    windDirection: "NE",
    pressure: 1013,
    lastUpdated: "2023-11-01T10:40:00Z",
    battery: 95
  },
  {
    id: 5,
    name: "Irrigation Controller 1",
    type: "irrigation",
    location: [12.52, 41.855],
    status: "active",
    flowRate: 25.4,
    unit: "L/min",
    lastUpdated: "2023-11-01T10:38:00Z",
    battery: 88
  }
]; 